"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityCrud = EntityCrud;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var react_hook_form_1 = require("react-hook-form");
var DataTable_1 = __importDefault(require("@components/custom/DataTable"));
var button_1 = require("@components/ui/button");
var input_1 = require("@components/ui/input");
var use_toast_1 = require("@hooks/use-toast");
var useEntityCRUD_1 = require("@container/pages/entities/common/hooks/useEntityCRUD");
var entitySheet_1 = __importDefault(require("@container/pages/entities/common/entitySheet"));
var react_i18next_1 = require("react-i18next");
var handleValidationErrors_1 = require("@utils/handleValidationErrors");
function EntityCrud(_a) {
    var _this = this;
    var _b;
    var endpoint = _a.endpoint, entityName = _a.entityName, columns = _a.columns, FormComponent = _a.formComponent, _c = _a.prepareFormData, prepareFormData = _c === void 0 ? function (d) { return d; } : _c, _d = _a.preparePostData, preparePostData = _d === void 0 ? function (d) { return d; } : _d, _e = _a.defaultPageSize, defaultPageSize = _e === void 0 ? 20 : _e, _f = _a.showReorder, showReorder = _f === void 0 ? false : _f, _g = _a.setIsReorderMode, setIsReorderMode = _g === void 0 ? function (d) { return d; } : _g, _h = _a.defaultSorting, defaultSorting = _h === void 0 ? null : _h, extraParams = _a.extraParams;
    var _j = (0, useEntityCRUD_1.useEntityCRUD)({
        endpoint: endpoint,
        entityName: entityName,
        defaultPageSize: defaultPageSize,
        defaultSorting: defaultSorting,
        extraParams: extraParams,
    }), listQuery = _j.listQuery, createMutation = _j.createMutation, updateMutation = _j.updateMutation, deleteMutation = _j.deleteMutation, pagination = _j.pagination, setSearchQuery = _j.setSearchQuery, setSorting = _j.setSorting, setPage = _j.setPage, setPageSize = _j.setPageSize, searchQuery = _j.searchQuery, fetchItemById = _j.fetchItemById, queryClient = _j.queryClient;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _k = (0, react_1.useState)(null), selectedId = _k[0], setSelectedId = _k[1];
    var _l = (0, react_1.useState)(false), isOpen = _l[0], setIsOpen = _l[1];
    var methods = (0, react_hook_form_1.useForm)();
    var setError = methods.setError, clearErrors = methods.clearErrors, reset = methods.reset;
    var handleSubmit = function (data) {
        var mutation = selectedId ? updateMutation : createMutation;
        var successHandler = {
            onSuccess: function (result) {
                (0, use_toast_1.toast)({
                    title: t('common|Success'),
                    description: selectedId
                        ? t("common|Record updated successfully")
                        : t("common|New record created"),
                });
                setIsOpen(false);
                setSelectedId(null);
                reset();
            },
            onError: function (error) {
                var _a, _b;
                var wasHandled = (0, handleValidationErrors_1.handleValidationErrors)((error === null || error === void 0 ? void 0 : error.response) || error, setError, clearErrors);
                if (!wasHandled) {
                    (0, use_toast_1.toast)({
                        variant: 'destructive',
                        title: t('common|Error'),
                        description: ((_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) ||
                            (error === null || error === void 0 ? void 0 : error.message) ||
                            t('common|Failed to save'),
                    });
                }
            },
        };
        if (selectedId) {
            if (data instanceof FormData) {
                data.append('id', selectedId);
                mutation.mutate(data, successHandler);
            }
            else {
                mutation.mutate(__assign({ id: selectedId }, data), successHandler);
            }
        }
        else {
            mutation.mutate(data, successHandler);
        }
    };
    var itemQuery = fetchItemById(selectedId || '');
    var handleEdit = function (id) {
        setSelectedId(id);
        setIsOpen(true);
    };
    (0, react_1.useEffect)(function () {
        if (itemQuery.data && selectedId) {
            reset(prepareFormData(itemQuery.data));
        }
        else if (!selectedId) {
            reset({});
        }
    }, [itemQuery.data, selectedId, reset, prepareFormData]);
    var handleDelete = function (selectedRows) { return __awaiter(_this, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, Promise.all(selectedRows.map(function (row) { return deleteMutation.mutateAsync(row.id); }))];
                case 1:
                    _a.sent();
                    (0, use_toast_1.toast)({
                        title: t('common|Deleted'),
                        description: t('common|{{value}} item(s) deleted.', {
                            value: selectedRows.length,
                        }),
                    });
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    (0, use_toast_1.toast)({
                        variant: 'destructive',
                        title: t('common|Error'),
                        description: t("common|Failed to delete item(s)"),
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleSearch = function (query) {
        setSearchQuery(query);
        setPage(1);
    };
    var handleClear = function () {
        // Reset all filters and sorting
        setSearchQuery('');
        setPage(1);
        setSorting(defaultSorting !== null && defaultSorting !== void 0 ? defaultSorting : { field: 'easy_id', direction: 'desc' });
        // Invalidate cache to force fresh data fetch
        queryClient.invalidateQueries({ queryKey: [entityName] });
    };
    var handleNextPage = function () { return setPage(pagination.page + 1); };
    var handlePreviousPage = function () { return setPage(pagination.page - 1); };
    var handleGoToFirstPage = function () { return setPage(1); };
    var handleGoToLastPage = function () { return setPage(pagination.totalPages); };
    var handleSortingChange = function (field, order) {
        setSorting({ field: field, direction: order });
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex justify-between items-center", children: [(0, jsx_runtime_1.jsxs)("h2", { className: "text-xl font-semibold", children: [t("entities|".concat(entityName)), ' '] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-2", children: [(0, jsx_runtime_1.jsx)(button_1.Button, { className: "w-fit", onClick: function () {
                                    setSelectedId(null);
                                    reset({});
                                    setIsOpen(true);
                                }, children: t('common|Create') }), showReorder && ((0, jsx_runtime_1.jsx)(button_1.Button, { variant: "outline", onClick: function () { return setIsReorderMode(true); }, disabled: !((_b = listQuery.data) === null || _b === void 0 ? void 0 : _b.length), children: "R\u00E9organiser" }))] })] }), (0, jsx_runtime_1.jsx)(input_1.Input, { value: searchQuery, onChange: function (e) { return handleSearch(e.target.value); }, placeholder: t('common|Search...') }), (0, jsx_runtime_1.jsx)(DataTable_1.default, { columns: columns, data: listQuery.data || [], loading: listQuery.isLoading || listQuery.isFetching, total: pagination.total, took: (pagination === null || pagination === void 0 ? void 0 : pagination.took) || 0, page: pagination.page, next: pagination.hasNext ? String(pagination.page + 1) : null, previous: pagination.hasPrevious ? String(pagination.page - 1) : null, handleNextPage: handleNextPage, handlePreviousPage: handlePreviousPage, pageSize: pagination.pageSize, total_pages: pagination.totalPages, handleSearchQuery: handleSearch, searchQuery: searchQuery, handleClear: handleClear, handleRowClick: function (row) { return handleEdit(row.id); }, handlePageSizeChange: setPageSize, handleGoToFirstPage: handleGoToFirstPage, handleGoToLastPage: handleGoToLastPage, handleSortChange: handleSortingChange, remoteSorting: pagination.sorting, handleDeleteItems: handleDelete, noElasticsearch: true, tableKey: entityName }), (0, jsx_runtime_1.jsx)(entitySheet_1.default, { isOpen: isOpen, onOpenChange: function (open) {
                    if (!open) {
                        if (!createMutation.isLoading && !updateMutation.isLoading) {
                            setIsOpen(open);
                            setSelectedId(null);
                            reset();
                        }
                    }
                    else {
                        setIsOpen(open);
                    }
                }, title: "".concat(selectedId ? 'Edit' : 'Create', " ").concat(entityName), formComponent: FormComponent, entityName: entityName, defaultValues: selectedId ? itemQuery.data : {}, onSubmit: handleSubmit, isSubmitting: createMutation.isLoading || updateMutation.isLoading, prepareFormData: prepareFormData, preparePostData: preparePostData, isLoading: selectedId ? itemQuery.isLoading : false, formMethods: methods })] }));
}
